import { http, HttpResponse, delay, type RequestHandler } from 'msw';
import { developmentPlans, homeExamples, inHomeScenario, isHomeScenario } from './homeScenarios';
import { loadHomeReference } from './reference.data';
import { canShare, isShareProjectInput } from './sharing';
import type { ProjectSummary } from './types';

export const API = '/api/plan-accueil-variantes';
let projects = homeExamples();

const notFound = () => HttpResponse.json({ message: 'Projet introuvable' }, { status: 404 });

async function sharing(request: Request, id: string, update: boolean) {
  const project = projects.find((item) => item.id === id);
  if (!project) return notFound();
  const input: unknown = await request.json().catch(() => null);
  if (!isShareProjectInput(input)) return HttpResponse.json({ message: 'Partage invalide' }, { status: 400 });
  const profile = request.headers.get('X-Viewer') ?? input.profile;
  if (!canShare(project, profile)) return HttpResponse.json({ message: 'Accès en lecture seule' }, { status: 403 });
  if (input.name === project.owner) return HttpResponse.json({ message: 'Propriétaire non modifiable' }, { status: 403 });
  if (!update && project.members.includes(input.name)) return HttpResponse.json({ message: 'Personne déjà invitée' }, { status: 409 });
  if (update && !project.members.includes(input.name)) return notFound();
  const next: ProjectSummary = {
    ...project, members: [...new Set([...project.members, input.name])],
    memberRoles: { ...project.memberRoles, [input.name]: input.role },
  };
  projects = projects.map((item) => item.id === id ? next : item);
  return HttpResponse.json(next);
}

export const handlers: RequestHandler[] = [
  http.get(`${API}/projects`, async ({ request }) => {
    const scenario = new URL(request.url).searchParams.get('scenario');
    if (!isHomeScenario(scenario)) return HttpResponse.json({ message: 'Scénario inconnu' }, { status: 400 });
    await delay(120);
    return HttpResponse.json(projects.filter((project) => inHomeScenario(project, scenario)));
  }),
  http.get(`${API}/referential`, async () => {
    try { return HttpResponse.json(await loadHomeReference()); }
    catch (error) {
      return HttpResponse.json({ message: error instanceof Error ? error.message : 'Référentiel indisponible' }, { status: 503 });
    }
  }),
  http.get(`${API}/projects/:id`, ({ params }) => {
    const project = projects.find((item) => item.id === params.id);
    return project ? HttpResponse.json({ project: { ...project, dju: { reference: 2500 } } }) : notFound();
  }),
  http.get(`${API}/projects/:id/plans`, async ({ params }) => {
    const project = projects.find((item) => item.id === params.id);
    if (!project) return notFound();
    if (!project.planCount) return HttpResponse.json([]);
    try {
      const reference = await loadHomeReference();
      return HttpResponse.json(developmentPlans(project, reference.buildingCount));
    } catch (error) {
      return HttpResponse.json({ message: error instanceof Error ? error.message : 'Référentiel indisponible' }, { status: 503 });
    }
  }),
  http.post(`${API}/projects/:id/sharing`, ({ request, params }) => sharing(request, String(params.id), false)),
  http.put(`${API}/projects/:id/sharing/:name`, ({ request, params }) => sharing(request, String(params.id), true)),
  http.post(`${API}/reset`, () => {
    projects = homeExamples();
    return HttpResponse.json({ ok: true });
  }),
];
